import { useAxios } from "../useAxios"
import { useAuthStore } from "../../../stores/auth/useAuthStore"

export const useCSVEnrichmentRequest = () => {
    const { sendRequest } = useAxios()
    const { store: { authData: { accessToken } } } = useAuthStore()

    const route = '/csv';

    const calculateCSVEnrichment = (payload: any) => {
        return sendRequest({
            slug: 'calculateCSVEnrichment',
            url: `${route}/calculate-enrichment-price`,
            method: 'POST',
            payload,
            displayToast: false
        })
    }

    const parseCsv = (payload: any) => {
        return sendRequest({
            slug: 'parseCsv',
            url: `${route}/parseCsv`,
            method: 'POST',
            payload,
            additionalHeaders: {
                'Content-Type': 'multipart/form-data'
            },
            displayToast: false,
            all: true
        })
    }

    const getEnrichedTransactionByClientSecret = (payload: any) => {
        return sendRequest({
            slug: 'getEnrichedTransactionByClientSecret',
            url: `${route}/enriched-transaction`,
            method: 'POST',
            payload,
            displayToast: false
        });
    }

    const getEnrichedCSVs = (params: any) => {
        return sendRequest({
            slug: 'getEnrichedCSVs',
            url: `${route}/enriched-csvs`,
            method: 'GET',
            params: {
                page: params.page,
                per_page: params.pageSize
            },
            all: true
        });
    }

    const getCreditOptions = () => {
        return sendRequest({
            slug: 'getCreditOptions',
            url: `${route}/credit-options`,
            method: 'GET',
            displayToast: false
        });
    }

    return {
        parseCsv,
        calculateCSVEnrichment,
        getEnrichedTransactionByClientSecret,
        getEnrichedCSVs,
        getCreditOptions,
    };
}